var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAuthenticated || _vm.userOnlyHaveOneOfRoles([_vm.Roles.Public, _vm.Roles.Tester]))?_c('div',[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }